import React from "react";
import SurveysContainer from "../containers/SurveysContainer";

export const SurveysPage: React.FunctionComponent = () => <SurveysContainer />;